import * as Yup from "yup";
import { ComplianceAPI } from "../../../api/compliance";

export const getValidationSchema = (withEmail: boolean) => {
  return Yup.object().shape({
    reason: Yup.string()
      .required("Reason is required")
      .max(500, "Reason must be at most 500 characters"),
    measure_taken: Yup.string()
      .required("Measure taken is required")
      .max(500, "Measure taken must be at most 500 characters"),
    ...(withEmail && {
      email: Yup.string()
        .email("Invalid email")
        .required("Email is required")
        .test("email-exists", "A note for this email already exists.", async function (value) {
          // Avoid error when email is not changed during edit
          if (this.parent.assignedEmail === value || !value) return true;

          const query = new URLSearchParams({ email: value });
          try {
            const res = await ComplianceAPI.getCustomerComplianceNotesRequest(
              query.toString(),
              undefined
            );
            return !res.data.count;
          } catch {
            return false;
          }
        }),
    }),
  });
};
